export enum OrderTypeAbbreviation {
  SO = 'SO',
  PO = 'PO',
}

export enum OrderType {
  SalesOrder = 'Sales Order',
  PurchaseOrder = 'Purchase Order',
}
